
import { LucideIcon } from "lucide-react";

interface TargetUserCardProps {
  title: string;
  description: string;
  Icon: LucideIcon;
}

export function TargetUserCard({ title, description, Icon }: TargetUserCardProps) {
  return (
    <div className="glass-card p-6 hover-scale flex items-start gap-4 shadow-md">
      <div className="bg-primary/10 p-3 rounded-full">
        <Icon className="h-6 w-6 text-primary" />
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
